import { isGrouped } from '../../GanttVisualization.helper';

import { hasConstraintHtml } from '../../../../utils/lookahead-common';

import addSubTaskIcon from '../../../../assets/img/newlookahead/name/child-arrow.png';
import addTaskIcon from '../../../../assets/img/newlookahead/name/add.png';
import deleteIcon from '../../../../assets/img/newlookahead/name/delete.png';
import duplicateIcon from '../../../../assets/img/newlookahead/duplicateactivity/dupli_acti.png';
import { isFeatureOn } from '../../../../utils/featureUtils';

export const testIds = {
  RENDER_ACTIONS_CONTAINER: 'RENDER_ACTIONS_CONTAINER'
};

const LVL_THREE = 6; /** Task depth allowed. Counter from 0. */

const TestWrapped = ({ children }) => (
  <span data-testid={testIds.RENDER_ACTIONS_CONTAINER}>{children}</span>
);

const RenderActions = ({ task = {}, gantt = {}, onlyRead = true }) => {
  const SHOW_INDICATOR_CONSTRAINT = false;
  const taskId = task?.id ? task.id : 0;
  const columnName = 'ACTIONS';
  const dataTestId =
    'data-testid="' +
    testIds.RENDER_ACTIONS_CONTAINER +
    '_' +
    taskId +
    '_' +
    columnName +
    '"';
  if (!window.activities || !task)
    return (
      <TestWrapped>
        <div></div>
      </TestWrapped>
    );
  const isOnlyReadElement = onlyRead || task.readonly;

  if (!gantt)
    return (
      <TestWrapped>
        <div></div>
      </TestWrapped>
    );

  const renderActions = (constraint = null) => {
    return `<div ${dataTestId}>
                ${
                  isOnlyReadElement
                    ? '-'
                    : `<span
                            class="task-actions"
                            style=" display: inline; visibility: visible"
                        >
                            ${
                              isGrouped()
                                ? ''
                                : `<span style=" display:flex">
                                            <span
                                              data-event-add-subtask
                                              style="cursor: pointer"
                                            >
                                              ${
                                                task.$level < LVL_THREE
                                                  ? `<img src=${addSubTaskIcon} width="15" style="opacity:0.3"/>`
                                                  : ''
                                              }
                                            </span>

                                            <span style="margin-right: -1px; margin-left: 6px; cursor: pointer">
                                                ${constraint}
                                            </span>

                                            <span style="cursor: pointer; margin-left: 7px" class='react-dhtmlx'>
                                                  <div class="PopConfirmHTML">
                                                            <div class="PopConfirmHTMLElement">
                                                                <img src=${deleteIcon} width="15" style="opacity:0.4" data-event-delete/>
                                                            </div>
                                                        </div>
                                                
                                            </span>
                                        </span>`
                            }
                        </span>`
                }
            </div>`;
  };

  const renderMain = () => {
    const hideAddBtn =
      gantt.subtradeRole &&
      gantt.subtradeRole.isSubtradeRole &&
      !gantt.subtradeRole.subtrade;

    let activityReferenceLvl = !task.isTask;

    const showDuplicate = !gantt.hasChild(task?.id) && !isGrouped();

    return `<div ${dataTestId}>
                <div
                    class="${
                      isFeatureOn('enable_lwp_18')
                        ? 'custom-div-row-container'
                        : ''
                    } text-btn-gantt-view-main"
                    style="
                        color: #121212;
                        font-weight: 600;
                        position: relative;
                        top: 0px !important
                    "
                >

                    <span>
                        <span style="
                            top: 0px;
                            position: relative;
                            display: inline;
                            visibility: ${hideAddBtn ? 'hidden' : 'visible'}
                        "
                        >
                            ${
                              !isOnlyReadElement && activityReferenceLvl
                                ? `<span                     data-event-create-task
                                    style="cursor: pointer; position: relative; margin-top: 10px; z-index: 1000; margin-left: -3px">
                                    <img src=${addTaskIcon} width="15"
                                  />
                                  </span>` //
                                : ' '
                            }

                            ${
                              !isOnlyReadElement
                                ? `<span
                                    style="margin-left: 10px; display: ${
                                      showDuplicate ? 'inline' : 'none'
                                    }"
                                    data-event-duplicate-task
                                  >
                                    ${
                                      showDuplicate
                                        ? `<img src=${duplicateIcon} width="14"
                                            style="cursor: pointer; position: relative; z-index: 1000"
                                            />`
                                        : `<img src=${duplicateIcon} width="14"
                                            style="cursor: pointer; position: relative; z-index: 1000"
                                            />`
                                    }
                                  </span>`
                                : ' '
                            }
                        </span>
                    </span>

                </div>
            </div>`;
  };

  const renderActivityTask = () => {
    /** is Task */
    const html_ponderator_constraint = `<span data-event-roadblock>
                ${hasConstraintHtml(
                  task,
                  null,
                  gantt.shouldOnlyRead,
                  gantt.t,
                  SHOW_INDICATOR_CONSTRAINT,
                  task.id,
                  'actions'
                )}
            </span>`;

    const taskName = renderActions(html_ponderator_constraint);

    return `<div ${dataTestId}>
                <div>
                    <span
                        class='text-btn-gantt-view-actions'
                        style="position: relative; text-align: center"
                    >
                        ${taskName}
                    </span>
                </div>
            </div>`;
  };

  const RenderActionsColumn = () => {
    let isOdd = false;
    if (gantt.oddColsConfig && task.type === 'activitytask') {
      isOdd = gantt.oddColsConfig.name;
    }
    if (!task?.type)
      return (
        <TestWrapped>
          <div></div>
        </TestWrapped>
      );
    return `<div
                class="${!isOdd ? 'odd-col' : 'non-odd-col'}"
                data-cell-type="actions"
                data-task-id="${task.id}"
                data-activity-id="${task.activityReference?.id}"
            >
                ${task.type === 'activitytask' ? renderActivityTask() : ''}
                ${task.type === 'main' ? renderMain() : ''}
            </div>`;
  };
  return RenderActionsColumn();
};

export default RenderActions;
